import type { DonorDonation } from '@/types/donorFinancialYear'
import { isManualDonationSource } from '@/helpers/donationSource'

/** UK Gift Aid uplift at 25% of the donation amount (pence). */
export function estimatedGiftAidPence(amountPence: number): number {
  return Math.round(amountPence * 0.25)
}

/** Whether the donor recorded Gift Aid on this donation. */
export function isDonationGiftAidDeclared(donation: DonorDonation): boolean {
  if (typeof donation.giftAidDeclared === 'boolean') {
    return donation.giftAidDeclared
  }
  return donation.giftaid > 0
}

export function isManualGiftAidRecord(donation: DonorDonation): boolean {
  return isManualDonationSource(donation.source)
}
